import axiosInstance from './axios';

export interface Plan {
    id: string;
    nombre: string;
    descripcion: string;
    precio: number;
    periodo: 'MENSUAL' | 'TRIMESTRAL' | 'SEMESTRAL' | 'ANUAL';
    maxEspacios: number;
    maxUsuarios: number;
    caracteristicas: string[];
    activo: boolean;
    empresasActivas?: number;
}

export interface CreatePlanData {
    nombre: string;
    descripcion?: string;
    precio: number;
    periodo: 'MENSUAL' | 'TRIMESTRAL' | 'SEMESTRAL' | 'ANUAL';
    maxEspacios: number;
    maxUsuarios: number;
    caracteristicas: string[];
    activo?: boolean;
}

export interface UpdatePlanData extends Partial<CreatePlanData> { }

/**
 * Obtener todos los planes
 */
export const getPlans = async (): Promise<Plan[]> => {
    const response = await axiosInstance.get<Plan[]>('/plans');
    return response.data;
};

/**
 * Obtener un plan por ID
 */
export const getPlanById = async (id: string): Promise<Plan> => {
    const response = await axiosInstance.get<Plan>(`/plans/${id}`);
    return response.data;
};

/**
 * Crear un nuevo plan
 */
export const createPlan = async (data: CreatePlanData): Promise<Plan> => {
    const response = await axiosInstance.post<Plan>('/plans', data);
    return response.data;
};

/**
 * Actualizar un plan
 */
export const updatePlan = async (id: string, data: UpdatePlanData): Promise<Plan> => {
    const response = await axiosInstance.put<Plan>(`/plans/${id}`, data);
    return response.data;
};

/**
 * Eliminar un plan
 */
export const deletePlan = async (id: string): Promise<{ message: string }> => {
    const response = await axiosInstance.delete<{ message: string }>(`/plans/${id}`);
    return response.data;
};
